export function isNextDay(d1: Date, d2: Date): boolean {
  const a = new Date(d1);
  const b = new Date(d2);

  a.setHours(0, 0, 0, 0);
  b.setHours(0, 0, 0, 0);

  const oneDayMs = 24 * 60 * 60 * 1000;
  const diffDays = (b.getTime() - a.getTime()) / oneDayMs;

  return diffDays === 1;
}
